"use client"

export function AnimatedBackground() {
  const schoolSupplies = [
    { emoji: "📚", delay: 0, duration: 7, x: "5%", y: "10%" },
    { emoji: "✏️", delay: 0.5, duration: 8.5, x: "85%", y: "15%" },
    { emoji: "📝", delay: 1, duration: 6.5, x: "10%", y: "70%" },
    { emoji: "🖊️", delay: 1.5, duration: 9, x: "80%", y: "60%" },
    { emoji: "📓", delay: 0.8, duration: 7.5, x: "20%", y: "35%" },
    { emoji: "✂️", delay: 1.2, duration: 8, x: "75%", y: "40%" },
    { emoji: "📐", delay: 0.3, duration: 7.8, x: "15%", y: "50%" },
    { emoji: "📏", delay: 1.8, duration: 8.2, x: "85%", y: "25%" },
    { emoji: "🎒", delay: 0.7, duration: 6.8, x: "25%", y: "80%" },
    { emoji: "🖍️", delay: 1.3, duration: 9.2, x: "70%", y: "75%" },
    { emoji: "📕", delay: 0.4, duration: 7.3, x: "30%", y: "20%" },
    { emoji: "📗", delay: 1.6, duration: 8.7, x: "90%", y: "50%" },
    { emoji: "📘", delay: 0.9, duration: 6.9, x: "10%", y: "25%" },
    { emoji: "📙", delay: 1.4, duration: 8.4, x: "55%", y: "15%" },
    { emoji: "🖌️", delay: 0.2, duration: 7.6, x: "45%", y: "85%" },
    { emoji: "📌", delay: 1.7, duration: 9.1, x: "65%", y: "10%" },
    { emoji: "📎", delay: 0.6, duration: 7.1, x: "35%", y: "65%" },
    { emoji: "✂️", delay: 1.1, duration: 8.3, x: "75%", y: "80%" },
    { emoji: "💼", delay: 0.5, duration: 7.7, x: "5%", y: "45%" },
    { emoji: "🎓", delay: 1.9, duration: 8.6, x: "50%", y: "70%" },
  ]

  const animationClasses = [
    "animate-icon-float-1",
    "animate-icon-float-2",
    "animate-icon-float-3",
    "animate-icon-float-4",
    "animate-icon-float-5",
  ]

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50 to-cyan-50 opacity-0" />

      <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-blue-300 to-blue-200 rounded-full opacity-30 animate-orb-float-1 blur-2xl" />
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-gradient-to-br from-orange-300 to-orange-200 rounded-full opacity-25 animate-orb-float-2 blur-3xl" />
      <div className="absolute top-1/2 right-1/4 w-24 h-24 bg-gradient-to-br from-cyan-300 to-blue-300 rounded-full opacity-35 animate-orb-float-3 blur-2xl" />

      <div
        className="absolute bottom-1/3 left-1/3 w-28 h-28 bg-gradient-to-br from-cyan-200 to-cyan-100 rounded-full opacity-20 animate-orb-float-1 blur-2xl"
        style={{ animationDuration: "10s" }}
      />
      <div
        className="absolute top-1/4 left-1/4 w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-300 rounded-full opacity-25 animate-orb-float-2 blur-xl"
        style={{ animationDuration: "9s" }}
      />

      {schoolSupplies.map((supply, index) => (
        <div
          key={index}
          className={`absolute text-4xl min-md:text-xxl ${animationClasses[index % 5]} grayscale-50 opacity-25`}
          style={{
            left: supply.x,
            top: supply.y,
            animationDelay: `${supply.delay}s`,
            animationDuration: `${supply.duration}s`,
            filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))",
          }}
        >
          {supply.emoji}
        </div>
      ))}

      <div className="absolute inset-0 bg-grid-pattern opacity-5" />

      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-cyan-400 via-transparent to-transparent opacity-10 blur-3xl rounded-full" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-orange-400 via-transparent to-transparent opacity-10 blur-3xl rounded-full" />
    </div>
  )
}
